import { z } from 'zod';

import type { TranslationKey } from '@/i18n-key';
import type { User } from '@/types/directory/User';

export const AssignReviewerFormFields = {
    reviewerAssignments: 'reviewerAssignments',
} as const;

const VALIDATION_ERROR_NO_REVIEWEES: TranslationKey =
    'evaluation360AssignReviewers.validation.noReviewees';
const VALIDATION_ERROR_MIN_REVIEWERS: TranslationKey =
    'evaluation360AssignReviewers.validation.minReviewers';

export type ReviewerAssignment = {
    revieweeId: string;
    reviewers: User[];
    reviewAudienceAssignmentId: string;
};

export const assignReviewerSchema = z.object({
    reviewerAssignments: z
        .array(
            z.object({
                revieweeId: z.string(),
                reviewers: z.array(z.any()),
                reviewAudienceAssignmentId: z.string(),
            }),
        )
        .refine((assignments) => assignments.length > 0, {
            message: VALIDATION_ERROR_NO_REVIEWEES,
        })
        .refine(
            (assignments) =>
                assignments.every((assignment) => assignment.reviewers.length >= 1) &&
                assignments.length > 0,
            {
                message: VALIDATION_ERROR_MIN_REVIEWERS,
            },
        ),
});

export type AssignReviewerFormData = z.infer<typeof assignReviewerSchema>;
